import * as React from 'react';
import { Select as ReactSelect } from 'react-select-virtualized';
import { Props as ReactSelectProps } from 'react-select/src/Select';
import { Field, FieldProps } from 'formik';
import { isEqual } from 'lodash';

import './Select.css';

export interface IOption<T> {
  label: string;
  value: T;
}
export interface IOptionGroup<T> {
  label: string;
  options: Array<IOption<T>>;
}

interface IFormSelectProps extends ReactSelectProps {
  name: string;
  options: Array<IOption<any>>;
  groups?: Array<IOptionGroup<any>>;
  className?: string;
  excludeOptions?: string[];
  initialValue?: any;
  secondary?: boolean;
}

interface ISelectProps extends ReactSelectProps<IOption<any>> {
  secondary?: boolean;
  simple?: boolean;
  disabled?: boolean;
}

const customStyles = {
  container: (provided: any) => ({
    ...provided,
    borderRadius: '.5rem',
  }),
  control: (provided: any) => ({
    ...provided,
    border: 'none',
    borderRadius: '.5rem',
    boxShadow: '3px 4px 0 0 rgba(0,0,0,0.05)',
    minHeight: 36,
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    color: state.isFocused ? '#00a1e4' : provided.color,
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: '.5rem',
    boxShadow: '0 3px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08)',
    overflow: 'hidden',
  }),
};
const customStylesSecondary = {
  container: (provided: any) => ({
    ...provided,
    borderRadius: '.5rem',
  }),
  control: (provided: any) => ({
    ...provided,
    background: '#eceeed',
    border: 'none',
    borderRadius: '.5rem',
    minHeight: 36,
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    color: state.isFocused ? '#00a1e4' : provided.color,
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: '.5rem',
    overflow: 'hidden',
  }),
  multiValue: (provided: any) => ({
    ...provided,
    background: '#fff',
  }),
};

export const Select = ({
  disabled = false,
  className = '',
  secondary = false,
  simple = false,
  ...props
}: ISelectProps) => {
  let styles = customStyles;
  if (secondary) {
    styles = customStylesSecondary;
  }
  return (
    <ReactSelect
      styles={styles}
      className={`${className}`}
      isDisabled={disabled}
      {...props}
    />
  );
};

export class FormSelect extends React.PureComponent<IFormSelectProps> {
  renderFormInput = ({ form, field }: FieldProps) => {
    const {
      options,
      groups,
      className,
      initialValue,
      secondary,
      isClearable,
      name,
      ...props
    } = this.props;

    const changeHandler = (choice: IOption<any>) => {
      if (choice === null) {
        form.setFieldValue(field.name, null);
        return;
      }
      form.setFieldValue(field.name, choice.value);
    };

    let value = options.find((option) => isEqual(option.value, field.value));
    if (!value) {
      value = initialValue || (options[0] && options[0].value);
      if (!initialValue) {
        form.setFieldValue(field.name, value);
      }
    }
    return (
      <ReactSelect
        options={groups || options}
        name={field.name}
        value={value}
        onChange={changeHandler}
        onBlur={field.onBlur}
        styles={secondary ? customStylesSecondary : customStyles}
        className={className || ''}
        grouped={Boolean(groups)}
        isClearable={isClearable || false}
        {...props}
      />
    );
  };

  render() {
    return <Field name={this.props.name} render={this.renderFormInput} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Select.tsx